import { defineRefiElement } from '../../utils/define-refi-element.js';
import { RefiTransitionPage } from './transition-page.component.js';
import '../../lit-element.js';
import '../../fs-heading.js';
import '../../query-assigned-elements.js';
import '../../index2.js';
import './assets/completeAnimation.js';
import './assets/curtainAnimation.js';

defineRefiElement('refi-common-transition-page', RefiTransitionPage);
